import React, { useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import { InputWrapper, PlusIconWrapper, StyledImage, UploadLogoIconButton } from './sheet';

import TextFieldBase from 'components/mui/Form/TextField/TextFieldBase';
import FormHelperText from '@mui/material/FormHelperText';

import BusinessIcon from '@mui/icons-material/Business';
import AddIcon from '@mui/icons-material/Add';
import { useIntl } from 'react-intl';
import {
  INVALID_FILE_TYPE,
  INVALID_FILE_SIZE,
  MAX_FILE_SIZE_MB,
} from 'pages/companies/components/CreateCompany/components/CreateCompanyForm/validation';

const UploadImg = ({ src = null, disabled, name, accept, input, meta = {} }) => {
  const [isDamagedImage, setIsDamagedImage] = useState(false);
  const fileInputRef = useRef(null);
  const { formatMessage } = useIntl();
  const { touched, error } = meta;
  const showError = touched && error;

  const onChangeInput = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      setIsDamagedImage(false);
      input.onChange(file);
    }
  };

  const getErrorMessage = (errorCode) => {
    if (errorCode === INVALID_FILE_TYPE) {
      return formatMessage({
        id: 'form.company.create.logo.invalid_file_type',
        defaultMessage: 'Invalid or unsupported file type. Accepted formats: PNG, JPG, JPEG, BMP',
      });
    }
    if (errorCode === INVALID_FILE_SIZE) {
      return formatMessage(
        {
          id: 'form.company.create.logo.invalid_file_size',
          defaultMessage: `The file size exceeds the ${MAX_FILE_SIZE_MB}MB maximum limit.`,
        },
        { maxSize: MAX_FILE_SIZE_MB },
      );
    }
    return errorCode;
  };

  return (
    <>
      <TextFieldBase
        inputRef={fileInputRef}
        id="fileInput"
        type="file"
        multiple={false}
        disabled={disabled}
        name={name}
        slotProps={{
          htmlInput: { accept },
        }}
        onChange={onChangeInput}
        sx={{ display: 'none' }}
        error={showError}
      />
      <InputWrapper>
        <label htmlFor="fileInput">
          <Grid container alignItems="center" justifyContent="center">
            {src && !error ? (
              <StyledImage
                src={src}
                alt="logo"
                onError={() => {
                  input.onChange(null);
                  setIsDamagedImage(true);
                }}
              />
            ) : (
              <UploadLogoIconButton onClick={() => fileInputRef.current?.click()}>
                <BusinessIcon
                  sx={{
                    width: 40,
                    height: 40,
                  }}
                  htmlColor="#66686A"
                />
                <PlusIconWrapper>
                  <AddIcon />
                </PlusIconWrapper>
              </UploadLogoIconButton>
            )}
          </Grid>
        </label>
        {showError && <FormHelperText error>{getErrorMessage(error)}</FormHelperText>}
        {isDamagedImage && (
          <FormHelperText error>
            {formatMessage({
              id: 'form.company.create.logo.invalid_file_type',
              defaultMessage: 'Invalid or unsupported file type. Accepted formats: PNG, JPG, JPEG, BMP',
            })}
          </FormHelperText>
        )}
      </InputWrapper>
    </>
  );
};

export default UploadImg;
